import { motion } from 'framer-motion'
import { cn } from '@jotta/utils/css'

type SpinnerProps = {
  size?: 'small' | 'medium' | 'large'
  className?: string
}

const Spinner = ({ size, className }: SpinnerProps) => {
  return (
    <motion.svg
      viewBox="0 0 50 50"
      className={cn(
        'h-[clamp(32px,10vmin,64px)] w-[clamp(32px,10vmin,64px)]',
        {
          'h-14 w-14': size === 'large',
          'h-9 w-9': size === 'medium',
          'h-5 w-5': size === 'small',
        },
        className,
      )}
      animate={{ rotate: 360 }}
      transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'linear',
      }}
    >
      <motion.circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        strokeWidth="3"
        strokeLinecap="round"
        className="stroke-primary"
        animate={{
          strokeDasharray: ['1, 200', '90, 200', '20, 200'],
          strokeDashoffset: [0, -40, -120], // Progressively moves the dash forward
        }}
        transition={{
          duration: 1.6,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />
    </motion.svg>
  )
}

export default Spinner
